const baseURL = '/accounts';

const newBaseURL = '/workspace';
const newListURL = '/workspaces';

const getData = R.prop('data');

function list() {
    return axios.get(`${newListURL}`).then(getData);
}

function create(data = { name: 'account' }) {
    return axios.post(`${baseURL}`, data).then(getData);
}

function getWorkspace({ with_biz_files } = {}) {
    return axios
        .get(`${newBaseURL}`, {
            params: {
                ...(with_biz_files ? { with_biz_files } : {}),
            },
        })
        .then(getData);
}

function deleteWorkspace(id) {
    return axios.delete(`${newBaseURL}/${id}`);
}

function update({ name = '', teams = [] }) {
    if (!name && !teams.length) {
        return Promise.reject('name and teams not provided');
    }

    return axios.put(`${newBaseURL}?level=team`, { name, teams }).then(getData);
}

function updateV2({ name = '', teams = [] }) {
    if (!name && !teams.length) {
        return Promise.reject('name and teams not provided');
    }

    return axios
        .put(`${newBaseURL}/edit?level=team`, { name, teams })
        .then(getData);
}

function setBusinessNoPerAccount({ id, reqBody }) {
    return axios.put(`${baseURL}/${id}/bizNo`, reqBody).then(getData);
}

function fetchTeams() {
    return axios.get(`${newBaseURL}/teams`).then(getData);
}

function fetchTeamsV2() {
    return axios.get(`${newBaseURL}/teamsV2`).then(getData);
}

// list multi accounts
function fetchMembers() {
    return axios.get(`${newBaseURL}/teams?level=member`).then(getData);
}

function fetchMembersV2() {
    return axios.get(`${newBaseURL}/teamsV2?level=member`).then(getData);
}

function invite({ teams = [], invitations = [] }) {
    return axios
        .post(`${newBaseURL}/invite`, {
            teams,
            invitations,
        })
        .then(getData);
}

function inviteV2({ teams = [], invitations = [] }) {
    return axios
        .post(`${newBaseURL}/inviteV2`, {
            teams,
            invitations,
        })
        .then(getData);
}

function updateMember(req) {
    return axios.put(`${newBaseURL}`, req).then(getData);
}

function updateMemberV2(req) {
    return axios.put(`${newBaseURL}/edit`, req).then(getData);
}

function deleteMember(req) {
    return axios.put(`${newBaseURL}`, req);
}

function deleteMemberV2(req) {
    return axios.put(`${newBaseURL}/edit`, req);
}

function getRawData(accountId) {
    return axios
        .get(`${baseURL}/rawData`, { params: { accountId } })
        .then(getData);
}

function uploadRawData(formData) {
    return axios
        .post(`/uploads/csv`, formData, {
            header: { 'Content-Type': 'multipart/form-data' },
        })
        .then(getData);
}

function updateRawData({ accountId, filePaths }) {
    return axios
        .post(`${baseURL}/rawData`, { filePaths }, { params: { accountId } })
        .then(getData);
}

function getKpiData(accountId) {
    return axios
        .get(`${baseURL}/${accountId}/kpiData`, { params: { accountId } })
        .then(getData);
}

function uploadKpiData(formData) {
    return axios
        .post(`uploads/kpi`, formData, {
            header: { 'Content-Type': 'multipart/form-data' },
        })
        .then(getData);
}

function updateKpiData({ accountId, filePaths }) {
    return axios
        .post(
            `${baseURL}/${accountId}/kpiData`,
            { filePaths },
            { params: { accountId } }
        )
        .then(getData);
}

function getAccount(accountId) {
    return axios.get(`backoffice${baseURL}/${accountId}`).then(getData);
}

function deletePendingUser({ invitation_id }) {
    return axios.delete(`${newBaseURL}/invite/${invitation_id}`);
}

function updateCurrency({ currency }) {
    return axios.put(newBaseURL, { currency }).then(getData);
}

function updateCurrencyV2({ currency }) {
    return axios.put(`${newBaseURL}/edit`, { currency }).then(getData);
}

function updateWorkspaceColorUrl({ color, websiteUrl }) {
    return axios
        .put(`${newBaseURL}/editNonSensitiveData`, { color, websiteUrl })
        .then(getData);
}

function hasCreditCard() {
    return axios.get(`${newBaseURL}/hasCreditCard`).then(getData);
}

export default {
    list,
    create,
    getWorkspace,
    deleteWorkspace,
    update,
    setBusinessNoPerAccount,
    fetchTeams,
    fetchMembers,
    invite,
    updateMember,
    deleteMember,
    getRawData,
    updateRawData,
    uploadRawData,
    getKpiData,
    uploadKpiData,
    updateKpiData,
    getAccount,
    deletePendingUser,
    updateCurrency,
    updateWorkspaceColorUrl,
    hasCreditCard,
    fetchTeamsV2,
    fetchMembersV2,
    inviteV2,
    updateV2,
    updateMemberV2,
    deleteMemberV2,
    updateCurrencyV2,
};
